export default {
  data () {
    return {
      isVisible: false
    }
  },

  mounted () {
    if (this.$el.nodeType !== Node.COMMENT_NODE) {
      this.observer = new IntersectionObserver((entries) => {
        this.isVisible = entries.some(item => item.isIntersecting)
      })

      this.$nextTick(() => {
        this.observer.observe(this.$el)
      })
    }
  }
}
